// Arquivo gerado por gerar_birds_ts.py.
// Pode editar description e artistId: são preservados ao gerar de novo.
import { Bird } from "./types";

// <dados-gerados>
export const birds: Bird[] = [
  {
    "id": 1,
    "slug": null,
    "order": "ANSERIFORMES",
    "family": "Anatidae",
    "subfamily": "Anatinae",
    "scientificName": "Amazonetta brasiliensis",
    "authority": "Gmelin, 1789",
    "popularName": "marreca-ananaí",
    "englishName": "Brazilian Teal",
    "audio": "/audios/Amazonetta brasiliensis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 2,
    "slug": null,
    "order": "ANSERIFORMES",
    "family": "Anatidae",
    "subfamily": "Anatinae",
    "scientificName": "Anas bahamensis",
    "authority": "Linnaeus, 1758",
    "popularName": "marreca-toicinho",
    "englishName": "White-cheeked Pintail",
    "audio": "/audios/Anas bahamensis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 3,
    "slug": null,
    "order": "ANSERIFORMES",
    "family": "Anatidae",
    "subfamily": "Anatinae",
    "scientificName": "Cairina moschata",
    "authority": "Linnaeus, 1758",
    "popularName": "pato-do-mato",
    "englishName": "Muscovy Duck",
    "audio": "/audios/Cairina moschata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 4,
    "slug": null,
    "order": "ANSERIFORMES",
    "family": "Anatidae",
    "subfamily": "Dendrocygninae",
    "scientificName": "Dendrocygna autumnalis",
    "authority": "Linnaeus, 1758",
    "popularName": "asa-branca",
    "englishName": "Black-bellied Whistling-Duck",
    "audio": "/audios/Dendrocygna autumnalis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 5,
    "slug": null,
    "order": "ANSERIFORMES",
    "family": "Anatidae",
    "subfamily": "Dendrocygninae",
    "scientificName": "Dendrocygna viduata",
    "authority": "Linnaeus,  1766",
    "popularName": "irerê",
    "englishName": "White-faced Whistling Duck",
    "audio": "/audios/Dendrocygna viduata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 6,
    "slug": null,
    "order": "SULIFORMES",
    "family": "Sulidae",
    "scientificName": "Sula leucogaster",
    "authority": "Boddaert, 1783",
    "popularName": "atobá-pardo",
    "englishName": "Brown Booby",
    "audio": "/audios/Sula leucogaster.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 7,
    "slug": null,
    "order": "SULIFORMES",
    "family": "Sulidae",
    "subfamily": "Phalacrocoracidae",
    "scientificName": "Nannopterum brasilianus",
    "authority": "Gmelin, 1789",
    "popularName": "biguá",
    "englishName": "Olivaceus Cormorant",
    "audio": "/audios/Nannopterum brasilianus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 8,
    "slug": null,
    "order": "SULIFORMES",
    "family": "Sulidae",
    "subfamily": "Fregatidae",
    "scientificName": "Fregata magnificens",
    "authority": "Matheus, 1914",
    "popularName": "fragata",
    "englishName": "Magnificent Frigatebird",
    "audio": "/audios/Fregata magnificens.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/fragata (Fregata magnificens)/illustrations/img_1.png"
      }
    ]
  },
  {
    "id": 9,
    "slug": "garça-branca-grande (Ardea alba)",
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Ardea alba",
    "authority": "Linnaeus,  1758",
    "popularName": "garça-branca-grande",
    "englishName": "Great Egrett",
    "audio": "/audios/Ardea alba.mp3",
    "photos": [
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-grande (Ardea alba)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 10,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Ardea cocoi",
    "authority": "Linnaeus,  1766",
    "popularName": "garça-moura",
    "englishName": "White-necked Heron",
    "audio": "/audios/Ardea cocoi.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 11,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Bubulcus ibis",
    "authority": "Linnaeus, 1758",
    "popularName": "garça-vaqueira",
    "englishName": "Cattle Egrett",
    "audio": "/audios/Bubulcus ibis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 12,
    "slug": "socozinho (Butorides striata)",
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Butorides striata",
    "authority": "Linnaeus, 1758",
    "popularName": "socozinho",
    "englishName": "Striated Heron",
    "audio": "/audios/Butorides striata.mp3",
    "photos": [
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/socozinho (Butorides striata)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 13,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Egretta caerulea",
    "authority": "Linnaeus, 1758",
    "popularName": "garça-azul",
    "englishName": "Little Blue Heron",
    "audio": "/audios/Egretta caerulea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 14,
    "slug": "garça-branca-pequena (Egretta thula)",
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Egretta thula",
    "authority": "Molina, 1782",
    "popularName": "garça-branca-pequena",
    "englishName": "Snowy Egrett",
    "audio": "/audios/Egretta thula.mp3",
    "photos": [
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_16.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_17.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_18.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_19.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_20.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_21.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_22.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_23.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/garça-branca-pequena (Egretta thula)/photos/img_24.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 15,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Nyctanassa violacea",
    "authority": "Linnaeus, 1758",
    "popularName": "savacu-de-coroa",
    "englishName": "Yellow-crowded Night-Heron",
    "audio": "/audios/Nyctanassa violacea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 16,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Nycticorax nycticorax",
    "authority": "Linnaeus, 1758",
    "popularName": "socó-dorminhoco",
    "englishName": "Black-crowned Night-Heron",
    "audio": "/audios/Nycticorax nycticorax.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 17,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "scientificName": "Syrigma sibilatrix",
    "authority": "Temminck, 1824",
    "popularName": "maria-faceira",
    "englishName": "Whistling Heron",
    "audio": "/audios/Syrigma sibilatrix.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 18,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "subfamily": "Threskiornitidae",
    "scientificName": "Platalea ajaja",
    "authority": "Linnaeus, 1758",
    "popularName": "colhereiro",
    "englishName": "Roseate Spoonbill",
    "audio": "/audios/Platalea ajaja.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 19,
    "slug": null,
    "order": "PELECONIFORMES",
    "family": "Ardeidae",
    "subfamily": "Threskiornitidae",
    "scientificName": "Theristicus caudatus",
    "authority": "Boddaert,  1763",
    "popularName": "curicaca",
    "englishName": "Buff-necked Ibis",
    "audio": "/audios/Theristicus caudatus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 20,
    "slug": null,
    "order": "CATHARTIFORMES",
    "family": "Cathartidae",
    "scientificName": "Cathartes aura",
    "authority": "Linnaeus, 1766",
    "popularName": "urubu-de-cabeça-vermelha",
    "englishName": "Turkey Vultur",
    "audio": "/audios/Cathartes aura.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 21,
    "slug": null,
    "order": "CATHARTIFORMES",
    "family": "Cathartidae",
    "scientificName": "Cathartes burrovianus",
    "authority": "Cassin, 1845",
    "popularName": "urubu-de-cabeça-amarela",
    "englishName": "Lesser Yellow-headed Vultur",
    "audio": "/audios/Cathartes burrovianus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 22,
    "slug": "urubu-preto (Coragyps atratus)",
    "order": "CATHARTIFORMES",
    "family": "Cathartidae",
    "scientificName": "Coragyps atratus",
    "authority": "Bechstein,  1793",
    "popularName": "urubu-preto",
    "englishName": "Black Vulture",
    "audio": "/audios/Coragyps atratus.mp3",
    "photos": [
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/urubu-preto (Coragyps atratus)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 23,
    "slug": null,
    "order": "ACCIPITRIFORMES",
    "family": "Accipitridae",
    "scientificName": "Heterospizias meridionalis",
    "authority": "Latham, 1790",
    "popularName": "gavião-caboclo",
    "englishName": "Savana Hawk",
    "audio": "/audios/Heterospizias meridionalis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 24,
    "slug": null,
    "order": "ACCIPITRIFORMES",
    "family": "Accipitridae",
    "scientificName": "Parabuteo unicinctus",
    "authority": "Temminck, 1824",
    "popularName": "gavião-asa-de-telha",
    "englishName": "Harri's Hawk",
    "audio": "/audios/Parabuteo unicinctus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 25,
    "slug": "gavião-carijó (Rupornis magnirostris)",
    "order": "ACCIPITRIFORMES",
    "family": "Accipitridae",
    "scientificName": "Rupornis magnirostris",
    "authority": "Gmelin, 1788",
    "popularName": "gavião-carijó",
    "englishName": "Roadside Hawk",
    "audio": "/audios/Rupornis magnirostris.mp3",
    "photos": [
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_16.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_17.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_18.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_19.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_20.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_21.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_22.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_23.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_24.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_25.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_26.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_27.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_28.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_29.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_30.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_31.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_32.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_33.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/gavião-carijó (Rupornis magnirostris)/photos/img_34.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 26,
    "slug": "jacupemba (Penelope superciliaris)",
    "order": "GALLIFORMES",
    "family": "Cracidae",
    "scientificName": "Penelope superciliaris",
    "authority": "Temminck,  1815",
    "popularName": "jacupemba",
    "englishName": "Rusty-margined Guan",
    "audio": "/audios/Penelope superciliaris.mp3",
    "photos": [
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/jacupemba (Penelope superciliaris)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 27,
    "slug": "carcará (Caracara plancus)",
    "order": "FALCONIFORMES",
    "family": "Falconidae",
    "scientificName": "Caracara plancus",
    "authority": "Miller, 1777",
    "popularName": "carcará",
    "englishName": "Crested Caracara",
    "audio": "/audios/Caracara plancus.mp3",
    "description": "O carcará é uma ave de rapina que se destaca pela sua habilidade de caçar em campos abertos. Com plumagem característica e um bico forte, é conhecido por sua agressividade ao defender seu território.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/carcará (Caracara plancus)/illustrations/img_1.png",
        "artistId": "fernanda-barbagelata"
      }
    ]
  },
  {
    "id": 28,
    "slug": "falcão-de-coleira (Falco femoralis)",
    "order": "FALCONIFORMES",
    "family": "Falconidae",
    "scientificName": "Falco femoralis",
    "authority": "Temminck, 1822",
    "popularName": "falcão-de-coleira",
    "englishName": "Aplomado Falcon",
    "audio": "/audios/Falco femoralis.mp3",
    "photos": [
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/falcão-de-coleira (Falco femoralis)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 29,
    "slug": "falcão-peregrino (Falco peregrinus)",
    "order": "FALCONIFORMES",
    "family": "Falconidae",
    "scientificName": "Falco peregrinus",
    "authority": "Tunstall, 1771",
    "popularName": "falcão-peregrino",
    "englishName": "Peregrine Falcon",
    "audio": "/audios/Falco peregrinus.mp3",
    "description": "O falcão peregrino é conhecido por sua incrível velocidade em voo, podendo atingir até 320 km/h durante um mergulho para capturar presas. É uma ave de rapina encontrada em diversas regiões do mundo, incluindo áreas urbanas.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/falcão-peregrino (Falco peregrinus)/illustrations/img_1.jpg",
        "artistId": "ana-beatriz-brenha"
      }
    ]
  },
  {
    "id": 30,
    "slug": "quiriquiri (Falco sparverius)",
    "order": "FALCONIFORMES",
    "family": "Falconidae",
    "scientificName": "Falco sparverius",
    "authority": "Linnaeus, 1758",
    "popularName": "quiriquiri",
    "englishName": "American Kestrel",
    "audio": "/audios/Falco sparverius.mp3",
    "photos": [
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quiriquiri (Falco sparverius)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 31,
    "slug": null,
    "order": "FALCONIFORMES",
    "family": "Falconidae",
    "scientificName": "Milvago chimachima",
    "authority": "Vieillot, 1816",
    "popularName": "carrapateiro",
    "englishName": "Yellow-headed Caracara",
    "audio": "/audios/Milvago chimachima.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 32,
    "slug": null,
    "order": "GRUIFORMES",
    "family": "Rallidae",
    "scientificName": "Aramides cajanea",
    "authority": "Statius Miller,  1776",
    "popularName": "saracura-três-potes",
    "englishName": "Grey-necked Wood-Rail",
    "audio": "/audios/Aramides cajanea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 33,
    "slug": null,
    "order": "GRUIFORMES",
    "family": "Rallidae",
    "scientificName": "Gallinula galeata",
    "authority": "Linnaeus,  1758",
    "popularName": "galinha-d'água",
    "englishName": "Common Moorhen",
    "audio": "/audios/Gallinula galeata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 34,
    "slug": null,
    "order": "GRUIFORMES",
    "family": "Rallidae",
    "scientificName": "Laterallus viridis",
    "authority": "Statius Miller,  1776",
    "popularName": "sanã-castanha",
    "englishName": "Russe-crowned Crake",
    "audio": "/audios/Laterallus viridis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 35,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "scientificName": "Charadrius collaris",
    "authority": "Vieillot, 1818",
    "popularName": "batuíra-de-coleira",
    "englishName": "Collared Plover",
    "audio": "/audios/Charadrius collaris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 36,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "scientificName": "Charadrius semipalmatus",
    "authority": "Bonaparte,  1825",
    "popularName": "batuíra-de-bando",
    "englishName": "Semipalmated Plover",
    "audio": "/audios/Charadrius semipalmatus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 37,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "scientificName": "Pluvialis dominica",
    "authority": "StaVieillottius Muller,  1776",
    "popularName": "batuiruçu",
    "englishName": "American Golden-Plove",
    "audio": "/audios/Pluvialis dominica.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 38,
    "slug": "quero-quero (Vanelus chilensis)",
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "scientificName": "Vanelus chilensis",
    "authority": "Molina, 1782",
    "popularName": "quero-quero",
    "englishName": "Southern Lapwing",
    "audio": "/audios/Vanelus chilensis.mp3",
    "photos": [
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/quero-quero (Vanelus chilensis)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 39,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Actitis macularius",
    "authority": "Linnaeus,  1776",
    "popularName": "maçarico-pintado",
    "englishName": "Spotted Sandpiper",
    "audio": "/audios/Actitis macularius.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 40,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Calidris fuscicollis",
    "authority": "Vieillot,  1819",
    "popularName": "maçarico-de-sobre-branco",
    "englishName": "White-rumped Sandpiper",
    "audio": "/audios/Calidris fuscicollis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 41,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Calidris melanotos",
    "authority": "Vieillot, 1819",
    "popularName": "maçarico-de-colete",
    "englishName": "Pectoral Sandpiper",
    "audio": "/audios/Calidris melanotos.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 42,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Tringa flavipes",
    "authority": "Gmelin, 1789",
    "popularName": "maçarico-de-perna-amarela",
    "englishName": "Lesser Yellowleg",
    "audio": "/audios/Tringa flavipes.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 43,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Tringa melanoleuca",
    "authority": "Gmelin, 1789",
    "popularName": "maçarico-de-perna-amarela",
    "englishName": "Greater Yellowleg",
    "audio": "/audios/Tringa melanoleuca.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 44,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Scolopacidae",
    "scientificName": "Tringa solitaria",
    "authority": "Wilson, 1813",
    "popularName": "maçarico-solitário",
    "englishName": "Solitary Sandpiper",
    "audio": "/audios/Tringa solitaria.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 45,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Jacanidae",
    "scientificName": "Jacana jacana",
    "authority": "Linnaeus, 1766",
    "popularName": "jaçanã",
    "englishName": "Wattled Jacana",
    "audio": "/audios/Jacana jacana.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 46,
    "slug": "pernilongo-de-costas-brancas (Himantopus melanurus)",
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Recurvirostridae",
    "scientificName": "Himantopus melanurus",
    "authority": "Vieillot, 1817",
    "popularName": "pernilongo-de-costas-brancas",
    "englishName": "Black-winged Stilt",
    "audio": "/audios/Himantopus melanurus.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/pernilongo-de-costas-brancas (Himantopus melanurus)/illustrations/img_1.png",
        "artistId": "fernanda-barbagelata"
      }
    ]
  },
  {
    "id": 47,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Laridae",
    "scientificName": "Chroicocephalus cirrocephalus",
    "authority": "Vieillot, 1818",
    "popularName": "gaivota-de-cabeça-cinza",
    "englishName": "Gray-Hooded Gull",
    "audio": "/audios/Chroicocephalus cirrocephalus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 48,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Laridae",
    "scientificName": "Larus dominicanus",
    "authority": "Lichtenstein, 1823",
    "popularName": "gaivotão",
    "englishName": "Kelp Gull",
    "audio": "/audios/Larus dominicanus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 49,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Sternidae",
    "scientificName": "Sterna hirundinacea",
    "authority": "Lesson, 1831",
    "popularName": "trinta-réis-de-bico-vermelho",
    "englishName": "South American Tern",
    "audio": "/audios/Sterna hirundinacea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 50,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Sternidae",
    "scientificName": "Thalasseus maximus",
    "authority": "Boddaert, 1823",
    "popularName": "trinta-réis-real",
    "englishName": "Royal Tern",
    "audio": "/audios/Thalasseus maximus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 51,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Sternidae",
    "scientificName": "Thalasseus acuflavidus",
    "authority": "Cabot, 1847",
    "popularName": "trinta-réis-de-bando",
    "englishName": "Sandwich Tern",
    "audio": "/audios/Thalasseus acuflavidus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 52,
    "slug": null,
    "order": "CHARADRIIFORMES",
    "family": "Charadriidae",
    "subfamily": "Rynchopidae",
    "scientificName": "Rynchops niger",
    "authority": "Linnaeus, 1758",
    "popularName": "talha-mar",
    "englishName": "Black-Skimmer",
    "audio": "/audios/Rynchops niger.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 53,
    "slug": "pombo-doméstico (Columba livia)",
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Columba livia",
    "authority": "Gmelin, 1787",
    "popularName": "pombo-doméstico",
    "englishName": "Rock Dove",
    "audio": "/audios/Columba livia.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/pombo-doméstico (Columba livia)/illustrations/img_1.jpg",
        "artistId": "alice-portela"
      }
    ]
  },
  {
    "id": 54,
    "slug": null,
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Columbina minuta",
    "authority": "Linnaeus,  1766",
    "popularName": "rolinha-de-asa-canela",
    "englishName": "Plain-breasted Ground-Dove",
    "audio": "/audios/Columbina minuta.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 55,
    "slug": "rolinha-roxa (Columbina talpacoti)",
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Columbina talpacoti",
    "authority": "Temminck, 1811",
    "popularName": "rolinha-roxa",
    "englishName": "Ruddy Ground-Dove",
    "audio": "/audios/Columbina talpacoti.mp3",
    "photos": [
      {
        "src": "/bird_images/rolinha-roxa (Columbina talpacoti)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 56,
    "slug": null,
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Geotrigon montana",
    "authority": "Linnaeus, 1758",
    "popularName": "pariri",
    "englishName": "Ruddy Quail-Dove",
    "audio": "/audios/Geotrigon montana.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 57,
    "slug": null,
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Leptotila verreauxi",
    "authority": "Bonaparte, 1855",
    "popularName": "juriti-pupu",
    "englishName": "White-tipped Dove",
    "audio": "/audios/Leptotila verreauxi.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 58,
    "slug": "pombão (Patagioenas picazuro)",
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Patagioenas picazuro",
    "authority": "Temminck, 1813",
    "popularName": "pombão",
    "englishName": "Picazuro Pigeon",
    "audio": "/audios/Patagioenas picazuro.mp3",
    "photos": [
      {
        "src": "/bird_images/pombão (Patagioenas picazuro)/photos/img_1.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/pombão (Patagioenas picazuro)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 59,
    "slug": null,
    "order": "COLUMBIFORMES",
    "family": "Columbidae",
    "scientificName": "Zenaida auriculata",
    "authority": "Des Murs, 1847",
    "popularName": "avoante",
    "englishName": "Eared Dove",
    "audio": "/audios/Zenaida auriculata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 60,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Amazona amazonica",
    "authority": "Linnaeus, 1766",
    "popularName": "curica",
    "englishName": "Orange-winged Parrot",
    "audio": "/audios/Amazona amazonica.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 61,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Amazona aestiva",
    "authority": "Linnaeus, 1758",
    "popularName": "papagaio-verdadeiro",
    "englishName": "Blue-fronted Parrot",
    "audio": "/audios/Amazona aestiva.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 62,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Aratinga auricapillus",
    "authority": "Kuhl,  1820",
    "popularName": "jandaia-de-testa-vermelha",
    "englishName": "Golden -Capped Parakeet",
    "audio": "/audios/Aratinga auricapillus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 63,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Eupsitula aurea",
    "authority": "Gmelin, 1788",
    "popularName": "periquito-rei",
    "englishName": "Peach-fronted Parakeet",
    "audio": "/audios/Eupsitula aurea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 64,
    "slug": "periquitão (Psittacara leucophtalmus)",
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Psittacara leucophtalmus",
    "authority": "Statius Miller, 1776",
    "popularName": "periquitão",
    "englishName": "White-eyed Parakeet",
    "audio": "/audios/Psittacara leucophtalmus.mp3",
    "photos": [
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_1.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_4.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_5.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_6.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/periquitão (Psittacara leucophtalmus)/photos/img_7.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 65,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Brotogeris chiriri",
    "authority": "Vieillot, 1818",
    "popularName": "periquito-de-encontro-amarelo",
    "englishName": "Yellow-chevroned Parakeet",
    "audio": "/audios/Brotogeris chiriri.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 66,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Coccyzus melacoryphys",
    "authority": "Vieillot, 1817",
    "popularName": "periquito-rico",
    "englishName": "Plain Parakeet",
    "audio": "/audios/Coccyzus melacoryphys.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 67,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Diopsittaca nobilis",
    "authority": "Linnaeus, 1758",
    "popularName": "maracanã-pequena",
    "englishName": "Red-shouldered Macaw",
    "audio": "/audios/Diopsittaca nobilis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 68,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Forpus xanthopterygius",
    "authority": "Spix, 1824",
    "popularName": "tuim",
    "englishName": "Blue-winged Parrotlet",
    "audio": "/audios/Forpus xanthopterygius.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 69,
    "slug": "caturrita (Myiopsitta monachus)",
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Myiopsitta monachus",
    "authority": "Boddaert, 1783",
    "popularName": "caturrita",
    "englishName": "Monk Parakeet",
    "audio": "/audios/Myiopsitta monachus.mp3",
    "photos": [
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/caturrita (Myiopsitta monachus)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 70,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Primolius maracana",
    "authority": "Vieillot, 1816",
    "popularName": "maracanã",
    "englishName": "Blue-winged Macaw",
    "audio": "/audios/Primolius maracana.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 71,
    "slug": null,
    "order": "PSITTACIFORMES",
    "family": "Psittacidae",
    "scientificName": "Pyrrhura frontalis",
    "authority": "Vieillot, 1817",
    "popularName": "tiriba-de-testa-vermelha",
    "englishName": "Maroon-bellied Parakeet",
    "audio": "/audios/Pyrrhura frontalis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 72,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "scientificName": "Coccyzus americanus",
    "authority": "Linnaeus, 1758",
    "popularName": "papa-lagarta-de-asa-vermelha",
    "englishName": "Yellow-billed Cuckoo",
    "audio": "/audios/Coccyzus americanus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 73,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "scientificName": "Coccyzus euleri",
    "authority": "Cabanis, 1873",
    "popularName": "papa-lagarta-de-euler",
    "englishName": "Pearly-breasted Cuckoo",
    "audio": "/audios/Coccyzus euleri.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 74,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "scientificName": "Coccyzus melacoryphys",
    "authority": "Veillot, 1817",
    "popularName": "papa-lagarta-acanelado",
    "englishName": "Dark-billed Cukoo",
    "audio": "/audios/Coccyzus melacoryphys.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 75,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "subfamily": "Crotophaginae",
    "scientificName": "Crotophaga ani",
    "authority": "Linnaeus, 1758",
    "popularName": "anu-preto",
    "englishName": "Smooth-billed Ani",
    "audio": "/audios/Crotophaga ani.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 76,
    "slug": "anu-branco (Guira guira)",
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "subfamily": "Crotophaginae",
    "scientificName": "Guira guira",
    "authority": "Gmelin, 1788",
    "popularName": "anu-branco",
    "englishName": "Guira Cuckoo",
    "audio": "/audios/Guira guira.mp3",
    "description": "Ave social e ruidosa, o anu-branco vive em bandos e é facilmente reconhecido pela plumagem clara com estrias marrons e a crista desalinhada. Alimenta-se principalmente de insetos e pequenos vertebrados.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/anu-branco (Guira guira)/illustrations/img_1.jpg",
        "artistId": "ana-beatriz-brenha"
      }
    ]
  },
  {
    "id": 77,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "subfamily": "Crotophaginae",
    "scientificName": "Piaya cayana",
    "authority": "Linnaeus, 1766",
    "popularName": "alma-de-gato",
    "englishName": "Squirrel Cuckoo",
    "audio": "/audios/Piaya cayana.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 78,
    "slug": null,
    "order": "CUCULIFORMES",
    "family": "Cuculidae",
    "subfamily": "Taperinae",
    "scientificName": "Tapera naevia",
    "authority": "Linnaeus, 1766",
    "popularName": "saci",
    "englishName": "Striped Cuckoo",
    "audio": "/audios/Tapera naevia.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 79,
    "slug": "coruja-da-igreja (Tyto furcata)",
    "order": "STRIGIFORMES",
    "family": "Tytonidae",
    "scientificName": "Tyto furcata",
    "authority": "Scopoli, 1769",
    "popularName": "coruja-da-igreja",
    "englishName": "Barn Owl",
    "audio": "/audios/Tyto furcata.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/coruja-da-igreja (Tyto furcata)/illustrations/img_1.jpg",
        "artistId": "ana-beatriz-brenha"
      }
    ]
  },
  {
    "id": 80,
    "slug": null,
    "order": "STRIGIFORMES",
    "family": "Tytonidae",
    "subfamily": "Strigidae",
    "scientificName": "Athene cunicularia",
    "authority": "Molina, 1782",
    "popularName": "coruja-buraqueira",
    "englishName": "Burrowing Owl",
    "audio": "/audios/Athene cunicularia.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 81,
    "slug": null,
    "order": "STRIGIFORMES",
    "family": "Tytonidae",
    "subfamily": "Strigidae",
    "scientificName": "Megascops choliba",
    "authority": "Vieillot, 1817",
    "popularName": "corujinha-do-mato",
    "englishName": "Tropical Screech-Owl",
    "audio": "/audios/Megascops choliba.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 82,
    "slug": null,
    "order": "STRIGIFORMES",
    "family": "Tytonidae",
    "subfamily": "Strigidae",
    "scientificName": "Asio clamator",
    "authority": "Vieillot, 1808",
    "popularName": "coruja-orelhuda",
    "englishName": "Striped Owl",
    "audio": "/audios/Asio clamator.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 83,
    "slug": null,
    "order": "CAPRIMULGIFORMES",
    "family": "Caprimulgidae",
    "scientificName": "Hydropsalis torquata",
    "authority": "Gmelin, 1789",
    "popularName": "bacurau-tesoura",
    "englishName": "Scissor-tailed Nightjar",
    "audio": "/audios/Hydropsalis torquata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 84,
    "slug": null,
    "order": "CAPRIMULGIFORMES",
    "family": "Caprimulgidae",
    "scientificName": "Nyctidromus albicollis",
    "authority": "Gmelin, 1789",
    "popularName": "Bacurau",
    "englishName": "Common Potoo or Pauraque",
    "audio": "/audios/Nyctidromus albicollis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 85,
    "slug": null,
    "order": "APODIFORMES",
    "family": "Apodidae",
    "scientificName": "Chaetura meridionalis",
    "authority": "Hellmayr, 1907",
    "popularName": "andorinhão-do-temporal",
    "englishName": "Sick's Swift",
    "audio": "/audios/Chaetura meridionalis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 86,
    "slug": null,
    "order": "APODIFORMES",
    "family": "Apodidae",
    "scientificName": "Streptoprocne zonaris",
    "authority": "Shaw, 1796",
    "popularName": "taperuçu-de-coleira-branca",
    "englishName": "White-collared Swift",
    "audio": "/audios/Streptoprocne zonaris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 87,
    "slug": "beija-flor-de-garganta-verde (Amazilia fimbriata)",
    "order": "APODIFORMES",
    "family": "Apodidae",
    "subfamily": "Trochillidae",
    "scientificName": "Amazilia fimbriata",
    "authority": "Gmelin, 1788",
    "popularName": "beija-flor-de-garganta-verde",
    "englishName": "Glittering-throated Emerald",
    "audio": "/audios/Amazilia fimbriata.mp3",
    "photos": [
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_16.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_17.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_18.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_19.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_20.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_21.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_22.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_23.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-de-garganta-verde (Amazilia fimbriata)/photos/img_24.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 88,
    "slug": null,
    "order": "APODIFORMES",
    "family": "Apodidae",
    "subfamily": "Trochillidae",
    "scientificName": "Chlorostilbon lucidus",
    "authority": "Shaw, 1812",
    "popularName": "besourinho-de-bico-vermelho",
    "englishName": "Glittering-belied Emerald",
    "audio": "/audios/Chlorostilbon lucidus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 89,
    "slug": "beija-flor-tesoura (Eupetomena macroura)",
    "order": "APODIFORMES",
    "family": "Apodidae",
    "subfamily": "Trochillidae",
    "scientificName": "Eupetomena macroura",
    "authority": "Gmelin, 1788",
    "popularName": "beija-flor-tesoura",
    "englishName": "Swallow-tailed Hummingbird",
    "audio": "/audios/Eupetomena macroura.mp3",
    "photos": [
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_16.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_17.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_18.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_19.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_20.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_21.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_22.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_23.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_24.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_25.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/beija-flor-tesoura (Eupetomena macroura)/photos/img_26.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 90,
    "slug": null,
    "order": "APODIFORMES",
    "family": "Apodidae",
    "subfamily": "Trochillidae",
    "scientificName": "Phaetornis ruber",
    "authority": "Linnaeus, 1758",
    "popularName": "rabo-branco-rubro",
    "englishName": "Reddish Hermit",
    "audio": "/audios/Phaetornis ruber.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 91,
    "slug": null,
    "order": "APODIFORMES",
    "family": "Apodidae",
    "subfamily": "Trochillidae",
    "scientificName": "Calliphlox ametysthina",
    "authority": "Boddaert,  1783",
    "popularName": "estrelinha-ametista",
    "englishName": "Amethyst Woodstar",
    "audio": "/audios/Calliphlox ametysthina.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 92,
    "slug": null,
    "order": "CORACIIFORMES",
    "family": "Alcedinidae",
    "scientificName": "Megaceryle torquata",
    "authority": "Linnaeus, 1766",
    "popularName": "martim-pescador-grande",
    "englishName": "Ringed Kingfisher",
    "audio": "/audios/Megaceryle torquata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 93,
    "slug": null,
    "order": "CORACIIFORMES",
    "family": "Alcedinidae",
    "scientificName": "Choroceryle amazona",
    "authority": "Latham,  1790",
    "popularName": "martim-pescador-verde",
    "englishName": "Amazon Kingfisher",
    "audio": "/audios/Choroceryle amazona.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 94,
    "slug": null,
    "order": "CORACIIFORMES",
    "family": "Alcedinidae",
    "subfamily": "Galbulidae",
    "scientificName": "Galbula ruficauda",
    "authority": "Cuvier, 1816",
    "popularName": "ariramba-de-cauda-ruiva",
    "englishName": "Rufous-tailed Jacamar",
    "audio": "/audios/Galbula ruficauda.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 95,
    "slug": "pica-pau-louro (Celeus flavescens)",
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Celeus flavescens",
    "authority": "Gmelin, 1788",
    "popularName": "pica-pau-louro",
    "englishName": "Pale-crested Woodpecker",
    "audio": "/audios/Celeus flavescens.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/pica-pau-louro (Celeus flavescens)/illustrations/img_1.jpg",
        "artistId": "alice-portela"
      }
    ]
  },
  {
    "id": 96,
    "slug": null,
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Colaptes campestris",
    "authority": "Vieillot, 1818",
    "popularName": "pica-pau-do-campo",
    "englishName": "Campo Flicker",
    "audio": "/audios/Colaptes campestris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 97,
    "slug": null,
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Colaptes melanochloros",
    "authority": "Gmelin, 1788",
    "popularName": "pica-pau-verde-barrado",
    "englishName": "Green-barrede Woodpecker",
    "audio": "/audios/Colaptes melanochloros.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 98,
    "slug": null,
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Melanerpes candidus",
    "authority": "Otto, 1796",
    "popularName": "pica-pau-branco",
    "englishName": "White Woodpecker",
    "audio": "/audios/Melanerpes candidus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 99,
    "slug": "picapauzinho-barrado (Picumnus cirratus)",
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Picumnus cirratus",
    "authority": "Temminck, 1825",
    "popularName": "picapauzinho-barrado",
    "englishName": "White-barred Piculet",
    "audio": "/audios/Picumnus cirratus.mp3",
    "photos": [
      {
        "src": "/bird_images/picapauzinho-barrado (Picumnus cirratus)/photos/img_1.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 100,
    "slug": null,
    "order": "PICIFORMES",
    "family": "Picidae",
    "scientificName": "Veniliornis maculifrons",
    "authority": "Spix, 1824",
    "popularName": "pica-pau-de-testa-pintada",
    "englishName": "Yellow-eared Woodpecker",
    "audio": "/audios/Veniliornis maculifrons.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 101,
    "slug": null,
    "order": "PICIFORMES",
    "family": "Picidae",
    "subfamily": "Buconidae",
    "scientificName": "Nystalus chacuru",
    "authority": "Vieillot, 1816",
    "popularName": "joão-bobo",
    "englishName": "White-eared Puff-bird",
    "audio": "/audios/Nystalus chacuru.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 102,
    "slug": "choca-listrada (Thamnophilus palliatus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "scientificName": "Thamnophilus palliatus",
    "authority": "Lichtenstein, 1823",
    "popularName": "choca-listrada",
    "englishName": "Chestnut-backed Antshrike",
    "audio": "/audios/Thamnophilus palliatus.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/choca-listrada (Thamnophilus palliatus)/illustrations/img_1.png",
        "artistId": "daniele-r"
      }
    ]
  },
  {
    "id": 103,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Dendrocolaptidae",
    "scientificName": "Lepidocolaptes angustirostris",
    "authority": "Vieillot, 1816",
    "popularName": "arapaçu-de-cerrado",
    "englishName": "Narrow-billed Wodpecker",
    "audio": "/audios/Lepidocolaptes angustirostris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 104,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Furnariidae",
    "scientificName": "Certhiaxis cinnamomeus",
    "authority": "Gmelin, 1788",
    "popularName": "curutié",
    "englishName": "Yellow-chined Spinetail",
    "audio": "/audios/Certhiaxis cinnamomeus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 105,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Furnariidae",
    "scientificName": "Furnarius figulus",
    "authority": "Lichtenstein, 1823",
    "popularName": "casaca-de-couro-da-lama",
    "englishName": "Wing-banded Hornero",
    "audio": "/audios/Furnarius figulus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 106,
    "slug": "joão-de-barro (Furnarius rufus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Furnariidae",
    "scientificName": "Furnarius rufus",
    "authority": "Gmelin, 1788",
    "popularName": "joão-de-barro",
    "englishName": "Rufous Hornero",
    "audio": "/audios/Furnarius rufus.mp3",
    "description": "O João de barro é famoso pela construção de seus ninhos em formato de forno, feitos com barro. É uma ave territorialista e muito comum nas áreas rurais do Brasil.",
    "photos": [
      {
        "src": "/bird_images/joão-de-barro (Furnarius rufus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/joão-de-barro (Furnarius rufus)/photos/img_2.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/joão-de-barro (Furnarius rufus)/photos/img_3.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": [
      {
        "src": "/bird_images/joão-de-barro (Furnarius rufus)/illustrations/img_1.jpg"
      }
    ]
  },
  {
    "id": 107,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Furnariidae",
    "scientificName": "Phacellodomus rufifrons",
    "authority": "Wied, 1821",
    "popularName": "graveteiro",
    "englishName": "Rufous-Fronted Thornbird",
    "audio": "/audios/Phacellodomus rufifrons.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 108,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Cotingidae",
    "scientificName": "Procnias nudicollis",
    "authority": "Vieillot, 1817",
    "popularName": "araponga",
    "englishName": "Bare-throated Bellbird",
    "audio": "/audios/Procnias nudicollis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 109,
    "slug": "ferreirinho-relógio (Todirostrum cinereum)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Rynchocyclidae",
    "scientificName": "Todirostrum cinereum",
    "authority": "Linnaeus, 1766",
    "popularName": "ferreirinho-relógio",
    "englishName": "Common-Tody  Flycatcher",
    "audio": "/audios/Todirostrum cinereum.mp3",
    "photos": [
      {
        "src": "/bird_images/ferreirinho-relógio (Todirostrum cinereum)/photos/img_1.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 110,
    "slug": "teque-teque (Todirostrum poliocephalum)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Rynchocyclidae",
    "scientificName": "Todirostrum poliocephalum",
    "authority": "Wied, 1831",
    "popularName": "teque-teque",
    "englishName": "Gray-Headed Tody-Flycatcher",
    "audio": "/audios/Todirostrum poliocephalum.mp3",
    "photos": [
      {
        "src": "/bird_images/teque-teque (Todirostrum poliocephalum)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 111,
    "slug": "bico-chato-amarelo (Tolmomyias flaviventris)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Rynchocyclidae",
    "scientificName": "Tolmomyias flaviventris",
    "authority": "Wied, 1831",
    "popularName": "bico-chato-amarelo",
    "englishName": "Yellow-breasted Flycatcher",
    "audio": "/audios/Tolmomyias flaviventris.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/bico-chato-amarelo (Tolmomyias flaviventris)/illustrations/img_1.jpg",
        "artistId": "alice-portela"
      }
    ]
  },
  {
    "id": 112,
    "slug": "risadinha (Camptostoma obsoletum)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Camptostoma obsoletum",
    "authority": "Temminck, 1824",
    "popularName": "risadinha",
    "englishName": "Southern Beardless Tyrannulet",
    "audio": "/audios/Camptostoma obsoletum.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/risadinha (Camptostoma obsoletum)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 113,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Contopus cinereus",
    "authority": "Spix, 1825",
    "popularName": "papa-moscas-cinzento",
    "englishName": "Tropical Pewee",
    "audio": "/audios/Contopus cinereus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 114,
    "slug": "guaracava-de-barriga-amarela (Elaenia flavogaster)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Elaenia flavogaster",
    "authority": "Thunberg, 1822",
    "popularName": "guaracava-de-barriga-amarela",
    "englishName": "Yellow-bellied Elaenia",
    "audio": "/audios/Elaenia flavogaster.mp3",
    "photos": [
      {
        "src": "/bird_images/guaracava-de-barriga-amarela (Elaenia flavogaster)/photos/img_1.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/guaracava-de-barriga-amarela (Elaenia flavogaster)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/guaracava-de-barriga-amarela (Elaenia flavogaster)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/guaracava-de-barriga-amarela (Elaenia flavogaster)/photos/img_4.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/guaracava-de-barriga-amarela (Elaenia flavogaster)/photos/img_5.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 115,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Empidonomus varius",
    "authority": "Vieillot, 1818",
    "popularName": "peitica",
    "englishName": "Variegated Flycatcher",
    "audio": "/audios/Empidonomus varius.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 116,
    "slug": "lavadeira-mascarada (Fluvicola nengeta)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Fluvicola nengeta",
    "authority": "Linnaeus, 1766",
    "popularName": "lavadeira-mascarada",
    "englishName": "Masked Water-Tyrant",
    "audio": "/audios/Fluvicola nengeta.mp3",
    "photos": [
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_16.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_17.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_18.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_19.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/lavadeira-mascarada (Fluvicola nengeta)/photos/img_20.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 117,
    "slug": "gibão-de-couro (Hirundinea ferruginea)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Hirundinea ferruginea",
    "authority": "Gmelin, 1788",
    "popularName": "gibão-de-couro",
    "englishName": "Cliff Flycatcher",
    "audio": "/audios/Hirundinea ferruginea.mp3",
    "photos": [
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_11.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/gibão-de-couro (Hirundinea ferruginea)/photos/img_12.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 118,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Lathrotriccus euleri",
    "authority": "Cabanis, 1868",
    "popularName": "enferrujado",
    "englishName": "Euler's Flycatcher",
    "audio": "/audios/Lathrotriccus euleri.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 119,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Machetornis rixosa",
    "authority": "Vieillot, 1819",
    "popularName": "suiriri-cavaleiro",
    "englishName": "Cattle Tyrant",
    "audio": "/audios/Machetornis rixosa.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 120,
    "slug": "neinei (Megarhyncus pitangua)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Megarhyncus pitangua",
    "authority": "Linnaeus, 1766",
    "popularName": "neinei",
    "englishName": "Boat-billied Flycatcher",
    "audio": "/audios/Megarhyncus pitangua.mp3",
    "photos": [
      {
        "src": "/bird_images/neinei (Megarhyncus pitangua)/photos/img_1.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/neinei (Megarhyncus pitangua)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 121,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Myiodynastes maculatus",
    "authority": "Statiu Miller, 1776",
    "popularName": "bem-te-vi-rajado",
    "englishName": "Streaked Flycatcher",
    "audio": "/audios/Myiodynastes maculatus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 122,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Myiarchus ferox",
    "authority": "Gmelin, 1789",
    "popularName": "maria-cavaleira",
    "englishName": "Short-crested Flycatcher",
    "audio": "/audios/Myiarchus ferox.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 123,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Myiophobus fasciatus",
    "authority": "Statius Miller, 1766",
    "popularName": "filipe",
    "englishName": "Bran-coloured Flycatcher",
    "audio": "/audios/Myiophobus fasciatus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 124,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Myiozetetes cayanensis",
    "authority": "Linaeus, 1766",
    "popularName": "bentevizinho-de-asa-ferrugínea",
    "englishName": "Rusty-margined Flycatcher",
    "audio": "/audios/Myiozetetes cayanensis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 125,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Myiozetetes similis",
    "authority": "Spix, 1825",
    "popularName": "bentevizinho-de-penacho-vermelho",
    "englishName": "Social Flycatcher",
    "audio": "/audios/Myiozetetes similis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 126,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Cnemotricus fuscatus",
    "authority": "Wied, 1831",
    "popularName": "guaracavuçu",
    "englishName": "Fuscous Flycatcher",
    "audio": "/audios/Cnemotricus fuscatus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 127,
    "slug": "bem-te-vi (Pitangus sulphuratus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Pitangus sulphuratus",
    "authority": "Linnaeus, 1766",
    "popularName": "bem-te-vi",
    "englishName": "Great Kiskadee",
    "audio": "/audios/Pitangus sulphuratus.mp3",
    "photos": [
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_13.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_14.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_15.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_16.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_17.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/photos/img_18.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": [
      {
        "src": "/bird_images/bem-te-vi (Pitangus sulphuratus)/illustrations/img_1.jpg",
        "artistId": "flavia-m"
      }
    ]
  },
  {
    "id": 128,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Pyrocephalus rubinus",
    "authority": "Boddaert, 1783",
    "popularName": "príncipe",
    "englishName": "Vermillion Flycatcher",
    "audio": "/audios/Pyrocephalus rubinus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 129,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Icterus pyrrhopterus",
    "authority": "Vieillot, 1819",
    "popularName": "encontro",
    "englishName": "Variable Oriole",
    "audio": "/audios/Icterus pyrrhopterus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 130,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Satrapa icterophrys",
    "authority": "Vieillot, 1818",
    "popularName": "suiriri-pequeno",
    "englishName": "Yellow-browed Tyrant",
    "audio": "/audios/Satrapa icterophrys.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 131,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Serpophaga subcristata",
    "authority": "Vieillot, 1827",
    "popularName": "alegrinho",
    "englishName": "White-crested Tyrranulet",
    "audio": "/audios/Serpophaga subcristata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 132,
    "slug": "piolhinho (Phyllomyias fasciatus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Phyllomyias fasciatus",
    "authority": "Thunberg,  1826",
    "popularName": "piolhinho",
    "englishName": "Planalto Tyrannulet",
    "audio": "/audios/Phyllomyias fasciatus.mp3",
    "photos": [
      {
        "src": "/bird_images/piolhinho (Phyllomyias fasciatus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 133,
    "slug": "suiriri (Tyrannus melancholicus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Tyrannus melancholicus",
    "authority": "Vieillot, 1819",
    "popularName": "suiriri",
    "englishName": "Tropical Kingbird",
    "audio": "/audios/Tyrannus melancholicus.mp3",
    "photos": [
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_7.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_8.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_9.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/photos/img_10.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": [
      {
        "src": "/bird_images/suiriri (Tyrannus melancholicus)/illustrations/img_1.jpg",
        "artistId": "daniele-r"
      }
    ]
  },
  {
    "id": 134,
    "slug": "tesourinha (Tyrannus savana)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Tyrannus savana",
    "authority": "Vieillot, 1808",
    "popularName": "tesourinha",
    "englishName": "Fork-tailed Flycatcher",
    "audio": "/audios/Tyrannus savana.mp3",
    "photos": [
      {
        "src": "/bird_images/tesourinha (Tyrannus savana)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 135,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tyrannidae",
    "scientificName": "Xolmis cinereus",
    "authority": "Vieillot, 1816",
    "popularName": "primavera",
    "englishName": "Grey Monjita",
    "audio": "/audios/Xolmis cinereus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 136,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Tytiridae",
    "scientificName": "Pachyramphus polychopterus",
    "authority": "Vieillot, 1818",
    "popularName": "caneleiro-preto",
    "englishName": "White-winged Becard",
    "audio": "/audios/Pachyramphus polychopterus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 137,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Vireonidae",
    "scientificName": "Vireo olivaceus",
    "authority": "Linnaeus,  1766",
    "popularName": "juruviara",
    "englishName": "Red-eyed Vireo",
    "audio": "/audios/Vireo olivaceus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 138,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Hirundo rustica",
    "authority": "Linnaeus, 1758",
    "popularName": "andorinha-de-bando",
    "englishName": "Barn Swallow",
    "audio": "/audios/Hirundo rustica.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 139,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Progne chalybea",
    "authority": "Gmelin, 1789",
    "popularName": "andorinha-grande",
    "englishName": "Gray-Brested Martin",
    "audio": "/audios/Progne chalybea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 140,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Progne tapera",
    "authority": "Vieillot, 1817",
    "popularName": "andorinha-do-campo",
    "englishName": "Brown-chested Martin",
    "audio": "/audios/Progne tapera.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 141,
    "slug": "andorinha-pequena-de-casa (Pygochelidon cyanoleuca)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Pygochelidon cyanoleuca",
    "authority": "Vieillot, 1817",
    "popularName": "andorinha-pequena-de-casa",
    "englishName": "Blue-and-white Swallow",
    "audio": "/audios/Pygochelidon cyanoleuca.mp3",
    "photos": [
      {
        "src": "/bird_images/andorinha-pequena-de-casa (Pygochelidon cyanoleuca)/photos/img_1.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 142,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Stelgidopteryx ruficollis",
    "authority": "Vieillot, 1817",
    "popularName": "andorinha-serradora",
    "englishName": "Southern Rough-winged Swallow",
    "audio": "/audios/Stelgidopteryx ruficollis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 143,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Hirundinidae",
    "scientificName": "Tachycineta leucorrhoa",
    "authority": "Vieillot, 1817",
    "popularName": "andorinha-de-sobre-branco",
    "englishName": "White-rumped Swallow",
    "audio": "/audios/Tachycineta leucorrhoa.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 144,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Trogloditidae",
    "scientificName": "Cantorchilus longirostris",
    "authority": "Vieillot, 1819",
    "popularName": "garrinchão-de-bico-grande",
    "englishName": "Long-billed Wren",
    "audio": "/audios/Cantorchilus longirostris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 145,
    "slug": "corruíra (Troglodytes musculus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Trogloditidae",
    "scientificName": "Troglodytes musculus",
    "authority": "Nauman, 1823",
    "popularName": "Corruíra",
    "englishName": "House Wren",
    "audio": "/audios/Troglodytes musculus.mp3",
    "photos": [
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/corruíra (Troglodytes musculus)/photos/img_8.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 146,
    "slug": "sabiá-poca (Turdus amaurochalinus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Turdidae",
    "scientificName": "Turdus amaurochalinus",
    "authority": "Cabanis, 1850",
    "popularName": "sabiá-poca",
    "englishName": "Creamy-bellied Thrush",
    "audio": "/audios/Turdus amaurochalinus.mp3",
    "photos": [
      {
        "src": "/bird_images/sabiá-poca (Turdus amaurochalinus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 147,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Turdidae",
    "scientificName": "Turdus flavipes",
    "authority": "Vieillot, 1818",
    "popularName": "sabiá-una",
    "englishName": "Yellow-legged Thrush",
    "audio": "/audios/Turdus flavipes.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 148,
    "slug": "sabiá-barranco (Turdus leucomelas)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Turdidae",
    "scientificName": "Turdus leucomelas",
    "authority": "Vieillot, 1818",
    "popularName": "sabiá-barranco",
    "englishName": "Pale-breasted Thrush",
    "audio": "/audios/Turdus leucomelas.mp3",
    "photos": [
      {
        "src": "/bird_images/sabiá-barranco (Turdus leucomelas)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/sabiá-barranco (Turdus leucomelas)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/sabiá-barranco (Turdus leucomelas)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 149,
    "slug": "sabiá-laranjeira (Turdus rufiventris)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Turdidae",
    "scientificName": "Turdus rufiventris",
    "authority": "Vieillot, 1818",
    "popularName": "sabiá-laranjeira",
    "englishName": "Rufous-bellied Thrush",
    "audio": "/audios/Turdus rufiventris.mp3",
    "photos": [
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_2.jpg",
        "artistId": "daniel-mello"
      },
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_4.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_5.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/sabiá-laranjeira (Turdus rufiventris)/photos/img_6.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 150,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Mimidae",
    "scientificName": "Mimus gilvus",
    "authority": "Vieillot, 1807",
    "popularName": "sabiá-da-praia",
    "englishName": "Tropical Mockingbird",
    "audio": "/audios/Mimus gilvus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 151,
    "slug": "sabiá-do-campo (Mimus saturninus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Mimidae",
    "scientificName": "Mimus saturninus",
    "authority": "Liechtenstein, 1823",
    "popularName": "sabiá-do-campo",
    "englishName": "Chalk-browed Mockingbird",
    "audio": "/audios/Mimus saturninus.mp3",
    "photos": [
      {
        "src": "/bird_images/sabiá-do-campo (Mimus saturninus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/sabiá-do-campo (Mimus saturninus)/photos/img_2.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/sabiá-do-campo (Mimus saturninus)/photos/img_3.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 152,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Motacillidae",
    "scientificName": "Anthus lutescens",
    "authority": "Pucheran, 1855",
    "popularName": "caminheiro-zumbidor",
    "englishName": "Yellowish Pipit",
    "audio": "/audios/Anthus lutescens.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 153,
    "slug": "tico-tico-do-campo (Ammodramus humeralis)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Passerilidae",
    "scientificName": "Ammodramus humeralis",
    "authority": "Bosc, 1792",
    "popularName": "tico-tico-do-campo",
    "englishName": "Grassland Sparrow",
    "audio": "/audios/Ammodramus humeralis.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/tico-tico-do-campo (Ammodramus humeralis)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 154,
    "slug": "tico-tico (Zonotrichia capensis (Statius Muller,1776)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Passerilidae",
    "scientificName": "Zonotrichia capensis (Statius Muller,1776",
    "authority": "",
    "popularName": "tico-tico",
    "englishName": "Rufous-collared Sparrow",
    "audio": "/audios/Zonotrichia capensis (Statius Muller,1776.mp3",
    "photos": [
      {
        "src": "/bird_images/tico-tico (Zonotrichia capensis (Statius Muller,1776)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/tico-tico (Zonotrichia capensis (Statius Muller,1776)/photos/img_2.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 155,
    "slug": "Cambacica (Coereba flaveola)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Coereba flaveola",
    "authority": "Linnaeus, 1758",
    "popularName": "Cambacica",
    "englishName": "Bananaquit",
    "audio": "/audios/Coereba flaveola.mp3",
    "photos": [
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_10.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_11.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_12.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_13.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_14.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_15.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_16.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_17.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_18.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_19.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_20.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_21.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_22.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_23.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_24.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_25.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_26.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_27.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/Cambacica (Coereba flaveola)/photos/img_28.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 156,
    "slug": "figuinha-do-mangue (Conirostrum bicolor)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Conirostrum bicolor",
    "authority": "Vieillot, 1809",
    "popularName": "figuinha-do-mangue",
    "englishName": "Bicoloured Conebill",
    "audio": "/audios/Conirostrum bicolor.mp3",
    "description": "Essa ave é adaptada para viver em ambientes de mangue, alimentando-se de pequenos insetos e frutos. Sua plumagem é discreta, ajudando-a a se camuflar entre a vegetação densa.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/figuinha-do-mangue (Conirostrum bicolor)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 157,
    "slug": "figuinha-de-rabo-castanho (Conirostrum speciosum)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Conirostrum speciosum",
    "authority": "Temminck, 1824",
    "popularName": "figuinha-de-rabo-castanho",
    "englishName": "Chestnut-vented Conebill",
    "audio": "/audios/Conirostrum speciosum.mp3",
    "description": "A figuinha de rabo castanho é uma pequena ave encontrada principalmente em áreas de vegetação rasteira. Seu nome vem da coloração marrom-avermelhada de sua cauda.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/figuinha-de-rabo-castanho (Conirostrum speciosum)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 158,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Nemosia pileata",
    "authority": "Boddaert, 1783",
    "popularName": "saíra-de-chapéu-preto",
    "englishName": "Hooded Tanager",
    "audio": "/audios/Nemosia pileata.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 159,
    "slug": "tiê-de-topete (Trichothraupis melanops)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Trichothraupis melanops",
    "authority": "Vieillot, 1818",
    "popularName": "tiê-de-topete",
    "englishName": "Black-goggled Tanager",
    "audio": "/audios/Trichothraupis melanops.mp3",
    "photos": [
      {
        "src": "/bird_images/tiê-de-topete (Trichothraupis melanops)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/tiê-de-topete (Trichothraupis melanops)/photos/img_2.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/tiê-de-topete (Trichothraupis melanops)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/tiê-de-topete (Trichothraupis melanops)/photos/img_4.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 160,
    "slug": "cardeal-do-nordeste (Paroaria dominicana)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Paroaria dominicana",
    "authority": "Linnaeus,  1758",
    "popularName": "cardeal-do-nordeste",
    "englishName": "Red-cowled Cardinal",
    "audio": "/audios/Paroaria dominicana.mp3",
    "description": "O cardeal do nordeste é uma ave de plumagem vibrante, com uma impressionante cor vermelha predominante. É encontrado principalmente na região nordeste do Brasil, onde é muito admirado pela sua beleza.",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/cardeal-do-nordeste (Paroaria dominicana)/illustrations/img_1.png",
        "artistId": "fernanda-barbagelata"
      }
    ]
  },
  {
    "id": 161,
    "slug": "tiê-sangue (Ramphocelus bresilius)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Ramphocelus bresilius",
    "authority": "Linnaeus, 1766",
    "popularName": "tiê-sangue",
    "englishName": "Brazilian Tanager",
    "audio": "/audios/Ramphocelus bresilius.mp3",
    "photos": [
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/tiê-sangue (Ramphocelus bresilius)/photos/img_6.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 162,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Saltator maximus",
    "authority": "Statius Muller, 1776",
    "popularName": "tempera-viola",
    "englishName": "Buf-throated Saltator",
    "audio": "/audios/Saltator maximus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 163,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Saltator similis",
    "authority": "d'Orvigny&Lafresnaye, 1837",
    "popularName": "trinca-ferro",
    "englishName": "Green-winged Saltator",
    "audio": "/audios/Saltator similis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 164,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Schistochlamys ruficapillus",
    "authority": "Vieillot, 1817",
    "popularName": "bico-de-veludo",
    "englishName": "Cinnamon Tanager",
    "audio": "/audios/Schistochlamys ruficapillus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 165,
    "slug": "coleirinho (Sporophila caerulescens)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Sporophila caerulescens",
    "authority": "Vieillot, 1823",
    "popularName": "coleirinho",
    "englishName": "Double-collared Seedeater",
    "audio": "/audios/Sporophila caerulescens.mp3",
    "photos": [
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/coleirinho (Sporophila caerulescens)/photos/img_7.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 166,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Sporophila collaris",
    "authority": "Boddaert, 1783",
    "popularName": "coleiro-do-brejo",
    "englishName": "Rusty-collared Seedeater",
    "audio": "/audios/Sporophila collaris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 167,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Sporophila lineola",
    "authority": "Linnaeus, 1758",
    "popularName": "bigodinho",
    "englishName": "Lined Seedeater",
    "audio": "/audios/Sporophila lineola.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 168,
    "slug": "tiê-preto (Tachyphonus coronatus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Tachyphonus coronatus",
    "authority": "Vieillot, 1822",
    "popularName": "tiê-preto",
    "englishName": "Ruby-crowned Tanager",
    "audio": "/audios/Tachyphonus coronatus.mp3",
    "photos": [
      {
        "src": "/bird_images/tiê-preto (Tachyphonus coronatus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      }
    ],
    "illustrations": []
  },
  {
    "id": 169,
    "slug": "saira-amarela (Tangara cayana)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Tangara cayana",
    "authority": "Linnaeus, 1766",
    "popularName": "saira-amarela",
    "englishName": "Burnished-buff Tanager",
    "audio": "/audios/Tangara cayana.mp3",
    "photos": [
      {
        "src": "/bird_images/saira-amarela (Tangara cayana)/photos/img_1.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/saira-amarela (Tangara cayana)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 170,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Tangara peruviana",
    "authority": "Desmarest, 1806",
    "popularName": "saíra-sapucaia",
    "englishName": "Black-backed Tangara",
    "audio": "/audios/Tangara peruviana.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 171,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Tersina viridis",
    "authority": "Illiger, 1811",
    "popularName": "saí-andorinha",
    "englishName": "Swallow-tanager",
    "audio": "/audios/Tersina viridis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 172,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Thlypopsis sordida",
    "authority": "D'Orbigny&Laphrasnaye",
    "popularName": "saí-canário",
    "englishName": "Orange-headed Tanager",
    "audio": "/audios/Thlypopsis sordida.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 173,
    "slug": "sanhaço-do-coqueiro (Thraupis palmarum)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Thraupis palmarum",
    "authority": "Wied, 1823",
    "popularName": "sanhaço-do-coqueiro",
    "englishName": "Palm Tanager",
    "audio": "/audios/Thraupis palmarum.mp3",
    "photos": [
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_3.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_4.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_5.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_6.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_7.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_8.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_9.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_10.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/sanhaço-do-coqueiro (Thraupis palmarum)/photos/img_11.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 174,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Thraupis sayaca",
    "authority": "Linnaeus, 1766",
    "popularName": "sanhaço-cinzento",
    "englishName": "Sayaca Tanager",
    "audio": "/audios/Thraupis sayaca.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 175,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Volatinia jacarina",
    "authority": "Linnaeus, 1766",
    "popularName": "tiziu",
    "englishName": "Blue-black Grassquit",
    "audio": "/audios/Volatinia jacarina.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 176,
    "slug": "cigarra-bambu (Haplospiza unicolor)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Haplospiza unicolor",
    "authority": "",
    "popularName": "cigarra-bambu",
    "englishName": "Uniform Finch",
    "audio": "/audios/Haplospiza unicolor.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/cigarra-bambu (Haplospiza unicolor)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 177,
    "slug": "canário-da-terra (Sicalis flaveola)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Sicalis flaveola",
    "authority": "Linnaeus, 1766",
    "popularName": "canário-da-terra",
    "englishName": "Saffron Finch",
    "audio": "/audios/Sicalis flaveola.mp3",
    "photos": [
      {
        "src": "/bird_images/canário-da-terra (Sicalis flaveola)/photos/img_1.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/canário-da-terra (Sicalis flaveola)/photos/img_2.jpg",
        "artistId": "luis-gustavo"
      },
      {
        "src": "/bird_images/canário-da-terra (Sicalis flaveola)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": [
      {
        "src": "/bird_images/canário-da-terra (Sicalis flaveola)/illustrations/img_1.jpg",
        "artistId": "ana-carolina-s"
      },
      {
        "src": "/bird_images/canário-da-terra (Sicalis flaveola)/illustrations/img_2.jpg",
        "artistId": "ana-carolina-s"
      }
    ]
  },
  {
    "id": 178,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Thraupidae",
    "scientificName": "Sicalis luteola",
    "authority": "Sparman, 1789",
    "popularName": "tipio",
    "englishName": "Grassland YellowFinch",
    "audio": "/audios/Sicalis luteola.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 179,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Parulidae",
    "scientificName": "Basileuterus culicivorus",
    "authority": "Deppe, 1830",
    "popularName": "pula-pula",
    "englishName": "Golden-crowned Warbler",
    "audio": "/audios/Basileuterus culicivorus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 180,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Parulidae",
    "scientificName": "Geothlyps aequinoctialis",
    "authority": "Gmelin, 1789",
    "popularName": "pia-cobra",
    "englishName": "Masked Yellowthroated",
    "audio": "/audios/Geothlyps aequinoctialis.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 181,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Parulidae",
    "scientificName": "Setophaga pitiayumi",
    "authority": "Vieillot, 1817",
    "popularName": "mariquita",
    "englishName": "Tropical Parula",
    "audio": "/audios/Setophaga pitiayumi.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 182,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Parulidae",
    "scientificName": "Cacicus haemorhous",
    "authority": "Linnaeus 1766",
    "popularName": "guaxe",
    "englishName": "Red-rumped Cacique",
    "audio": "/audios/Cacicus haemorhous.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 183,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Chrysomus ruficapillus",
    "authority": "Vieillot, 1819",
    "popularName": "garibaldi",
    "englishName": "Chestnut-capped Blackbird",
    "audio": "/audios/Chrysomus ruficapillus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 184,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Gnorimopsar chopi",
    "authority": "Vieillot,  1819",
    "popularName": "pássaro-preto",
    "englishName": "Chopi Blackbird",
    "audio": "/audios/Gnorimopsar chopi.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 185,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Icterus jmacaii",
    "authority": "Gmelin, 1788",
    "popularName": "corrupião",
    "englishName": "Campo Troupial",
    "audio": "/audios/Icterus jmacaii.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 186,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Icterus pyrrhopterus",
    "authority": "Vieillot, 1819",
    "popularName": "inhapim",
    "englishName": "Variable Oriole",
    "audio": "/audios/Icterus pyrrhopterus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 187,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Sturnella superciliaris",
    "authority": "Linnaeus, 1758",
    "popularName": "polícia-inglesa-do-sul",
    "englishName": "White-browed Blackbird",
    "audio": "/audios/Sturnella superciliaris.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 188,
    "slug": "vira-bosta (Molothrus bonariensis)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Molothrus bonariensis",
    "authority": "Gmelin, 1789",
    "popularName": "vira-bosta",
    "englishName": "Shiny Cowbird",
    "audio": "/audios/Molothrus bonariensis.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/vira-bosta (Molothrus bonariensis)/illustrations/img_1.png",
        "artistId": "fernanda-barbagelata"
      }
    ]
  },
  {
    "id": 189,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Molothrus oryzivorus",
    "authority": "Gmelin, 1788",
    "popularName": "iraúna-grande",
    "englishName": "Giant Cowbird",
    "audio": "/audios/Molothrus oryzivorus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 190,
    "slug": "chupim-do-brejo (Pseudoleistes guirahuro)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Icteridae",
    "scientificName": "Pseudoleistes guirahuro",
    "authority": "Vieillot, 1819",
    "popularName": "chupim-do-brejo",
    "englishName": "Yellow-ramped Marhbird",
    "audio": "/audios/Pseudoleistes guirahuro.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/chupim-do-brejo (Pseudoleistes guirahuro)/illustrations/img_1.png",
        "artistId": "fernanda-barbagelata"
      }
    ]
  },
  {
    "id": 191,
    "slug": "gralha-do-campo (Cyanocorax cristatellus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Corvidae",
    "scientificName": "Cyanocorax cristatellus",
    "authority": "",
    "popularName": "gralha-do-campo",
    "englishName": "Curl-crested Jay",
    "audio": "/audios/Cyanocorax cristatellus.mp3",
    "photos": [],
    "illustrations": [
      {
        "src": "/bird_images/gralha-do-campo (Cyanocorax cristatellus)/illustrations/img_1.jpeg",
        "artistId": "yan-casares"
      }
    ]
  },
  {
    "id": 192,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Fringilidae",
    "scientificName": "Spinus magellanicus",
    "authority": "Vieillot, 1805",
    "popularName": "pintassilgo",
    "englishName": "Hooded Siskin",
    "audio": "/audios/Spinus magellanicus.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 193,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Fringilidae",
    "scientificName": "Euphonia chlorotica",
    "authority": "Linnaeus, 1766",
    "popularName": "fim-fim",
    "englishName": "Purple-throated Euphonia",
    "audio": "/audios/Euphonia chlorotica.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 194,
    "slug": null,
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Fringilidae",
    "scientificName": "Euphonia violacea",
    "authority": "Linnaeus, 1758",
    "popularName": "gaturamo-verdadeiro",
    "englishName": "Violaceous Euphonia",
    "audio": "/audios/Euphonia violacea.mp3",
    "photos": [],
    "illustrations": []
  },
  {
    "id": 195,
    "slug": "pardal (Passer domesticus)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Passeridae",
    "scientificName": "Passer domesticus",
    "authority": "Linnaeus, 1758",
    "popularName": "pardal",
    "englishName": "House Sparrow",
    "audio": "/audios/Passer domesticus.mp3",
    "photos": [
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_1.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_2.jpg",
        "artistId": "luisa-melo"
      },
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_4.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_5.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/pardal (Passer domesticus)/photos/img_6.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  },
  {
    "id": 196,
    "slug": "bico-de-lacre (Estrilda astrild)",
    "order": "PASSERIFORMES",
    "family": "Thamnophilidae",
    "subfamily": "Estrildidae",
    "scientificName": "Estrilda astrild",
    "authority": "Bonaparte, 1850",
    "popularName": "bico-de-lacre",
    "englishName": "Common Waxbill",
    "audio": "/audios/Estrilda astrild.mp3",
    "photos": [
      {
        "src": "/bird_images/bico-de-lacre (Estrilda astrild)/photos/img_1.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/bico-de-lacre (Estrilda astrild)/photos/img_2.jpg",
        "artistId": "silvia-lorenz"
      },
      {
        "src": "/bird_images/bico-de-lacre (Estrilda astrild)/photos/img_3.jpg",
        "artistId": "silvia-lorenz"
      }
    ],
    "illustrations": []
  }
];
// </dados-gerados>

export const getBirdById = (id: number) => birds.find((b) => b.id === id);

export const getBirdsByName = (termo: string) => {
  const t = termo.toLowerCase();
  return birds.filter(
    (b) => b.popularName.toLowerCase().includes(t) ||
      b.scientificName.toLowerCase().includes(t)
  );
};

export const getMediaByArtist = (artistId: string) =>
  birds.flatMap((b) =>
    [...b.photos, ...b.illustrations]
      .filter((m) => m.artistId === artistId)
      .map((m) => ({ ...m, bird: b }))
  );
